import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import clsx from 'clsx';
import * as styles from './StarRating.module.scss';
import { Icon } from '../Icon/Icon';
const Name = 'StarRating';
export const StarRating = ({ numberOfStars, initialRate = 0, onRateClick, displayOnly = false, className, }) => {
    const [currentRate, setCurrentRate] = useState(initialRate - 1);
    const handleOnClick = (index) => {
        if (displayOnly) {
            return;
        }
        setCurrentRate(index);
        //we want rating from 1 not 0
        if (onRateClick) {
            setTimeout(() => onRateClick(index + 1), (index + 1) * 100 + 100);
        }
    };
    return (_jsx("div", { className: styles.container, "data-component": Name, children: [...Array(numberOfStars)].map((_, index) => (_jsx("button", { className: clsx(styles.star, displayOnly && styles.displayOnly, index <= currentRate && styles.isChecked, className), onClick: () => handleOnClick(index), tabIndex: displayOnly ? -1 : 0, "aria-label": `${index} star rating`, children: _jsx(Icon, { name: "star", size: 32, "aria-label": "Star" }) }, `star_rate_${index}`))) }));
};
